var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#323232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14.667h10.667V4H4v10.667zm2.667-8H12V12H6.667V6.667zM4 28h10.667V17.333H4V28zm2.667-8H12v5.333H6.667V20zM17.333 4v10.667H28V4H17.333zm8 8H20V6.667h5.333V12zM28 25.333h-2.667V28H28v-2.667zm-8-8h-2.667V20H20v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 20H20v2.667h2.667V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.667h-2.667v2.667H20v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 25.333H20V28h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.334 22.667h-2.667v2.667h2.667v-2.667zm0-5.334h-2.667V20h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 20h-2.667v2.667H28V20z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.72ec87d71b36e141e01a055b10c3f946.svg";
export { ForwardRef as ReactComponent };